<template>
  <custom-callout
    :border-color="processStatus(process.batchStatusId)"
    class="mb-3 custom-callout results-callout"
    :has-toggle="false"
  >
    <div class="row py-2">
      <div class="col-md-2 results-callout__status">
        <custom-balloon
          :background-color="processStatus(process.batchStatusId)"
          :text="process.batchLoadStatusName"
        />
        <div class="font-weight-normal color-secondary-6 font-14 mt-3 px-3">
          Periodo:
        </div>
        <div class="color-black font-16 px-3">
          {{ getMonth(process.monthNumber) }} {{ process.year }}
        </div>
      </div>
      <div class="col-md-8 border-left pl-10">
        <div class="row pt-4">
          <div class="col-1">
            <div class="font-weight-normal color-secondary-6 font-14">
              Servicio:
            </div>
            <div class="color-black font-16 font-weight-bold">
              {{ process.batchLoadServiceName }}
            </div>
          </div>
          <div class="col ml-5 ml-md-1 ml-sm-0">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Fecha Creación:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ process.createdDate | date }}
            </div>
          </div>
          <div class="col ml-5 ml-md-1 ml-sm-0">
            <div class="color-gray-6 font-14 font-weight-normal">
              Usuario Creación:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ process.createdBy }}
            </div>
          </div>
          <div class="col ml-5 ml-md-1 ml-sm-0">
            <div class="color-gray-6 font-14 font-weight-normal">
              Fecha Actualización:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ process.modifiedDate | date('dd MMM yyyy') }}
            </div>
          </div>
          <div class="col ml-5 ml-md-1 ml-sm-0">
            <div class="color-gray-6 font-14 font-weight-normal">
              Usuario Actualización:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ process.modifiedBy }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2 text-right pr-5 pt-4">
        <drop-down :items="getProcessActions" />
      </div>
    </div>
    <row-detail
      v-if="openSectionProcess"
      class="mt-3 bg-white"
      :model="this.process"
      @on-save="processAction"
    />
  </custom-callout>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import { getReport as _getReport } from '@/modules/shared/loadingprocessreport.api.js';
import _generalApi from '@/modules/app/api';
import batchServiceTypes from '@/utils/constants/batchServiceTypes.js';
import batchStatus from '@/utils/constants/batchStatus.js';
import RowDetail from './RowDetail';

export default {
  name: 'RowLoadProcess',
  components: {
    CustomBalloon,
    CustomCallout,
    RowDetail,
    DropDown,
  },
  props: {
    process: {
      type: Object,
      default: () => {
        return {
          batchLoadControlId: null,
          academicYearId: null,
          monthNumber: null,
          year: null,
          batchStatusId: null,
          batchLoadStatusName: null,
          batchLoadServiceId: null,
          errorDescription: null,
          totalGrossCostAmt: null,
          totalAutoAdjustmentAmt: null,
          totalManualAdjustmentAmt: null,
          totalApprovedAmt: null,
          totalDeniedManualGrossCostAmt: null,
          totalDeniedAutoGrossCostAmt: null,
          academicYearDescription: null,
          batchLoadServiceName: null,
          regionId: null,
          studentSieId: null,
          peiAnalysisServiceId: null,
          modifiedDate: null,
          modifiedBy: null,
          createdDate: null,
          createdBy: null,
        };
      },
    },
  },
  data() {
    return {
      statusColors: {
        1: {
          class: 'yellow',
        },
        2: {
          class: 'green-light',
        },
        3: {
          class: 'pink pink-error',
        },
      },
      openSectionProcess: false,
    };
  },
  computed: {
    getProcessActions() {
      return [
        {
          label: 'Ver Reporte',
          icon: 'fas fa-clipboard-list-check color-primary-1',
          click: () => {
            this.getReport(this.process);
          },
        },
        {
          label: 'Carga de estudiante',
          icon: 'fas fa-user-check color-primary-1',
          click: () => {
            this.openSection();
          },
          border: 'top',
          visible: this.validateActionForSection(this.process),
        },
      ];
    },
    amountClass() {
      return (price) =>
        Math.sign(price) >= 0 ? 'color-green' : 'color-secondary-28';
    },
  },
  methods: {
    validateActionForSection(row) {
      const validPermissionAndStatus =
        row.batchStatusId == batchStatus.Completado &&
        this.userHasPermissions('scholarship.loadingprocess.add');
      if (row.batchLoadServiceId == batchServiceTypes.Educativo) {
        if (
          row.batchLoadControlId == row.lastBatchControlForEducation &&
          validPermissionAndStatus
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          row.batchLoadControlId == row.lastBatchControlForTherapy &&
          validPermissionAndStatus
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    openSection() {
      this.openSectionProcess = true;
    },
    processAction(row) {
      this.openSectionProcess = false;
      this.$emit('on-update', row);
    },
    processStatus(status) {
      return this.statusColors[status].class;
    },
    goToPage(page) {
      this.$emit('change:page', page);
    },
    getMonth(value) {
      var months = {
        1: 'Enero',
        2: 'Febrero',
        3: 'Marzo',
        4: 'Abril',
        5: 'Mayo',
        6: 'Junio',
        7: 'Julio',
        8: 'Agosto',
        9: 'Septiembre',
        10: 'Octubre',
        11: 'Noviembre',
        12: 'Diciembre',
      };
      return months[value];
    },
    async getReport(row) {
      if (row.batchLoadControlId) {
        await _getReport(
          row.batchLoadControlId,
          row.academicYearId,
          row.monthNumber
        ).then((response) => {
          _generalApi.ConvertToBlob(response.data);
        });
      }
    },
  },
};
</script>
